// Todo: should this come from db?
export const CixonTables = [
  {
    name: 'cixon_chart',
    value: 'cixon_chart',
    fields: [
      'fondnr',
      'isin',
      'datum',
      'waehrung',
      'preis'
    ],
  },
  {
    name: 'cixon_stammdaten_extension',
    value: 'cixon_stammdaten_extension',
    fields: [
      'fondnr',
      'isin',
      'datum',
      'srriwert',
      'wkn',
      'fondsvermoegen',
      'askvermoegen',
      'ausgabepreis',
      'ruecknahmepreis',
      'anteilwert',
      'ter',
      'terDate',
      'ruecknahmeabschlag',
      'ausgabeaufschlag',
      'm1'
    ],
  },
  {
    name: 'cixon_wertentwicklung_vergangen',
    value: 'cixon_wertentwicklung_vergangen',
    fields: [
      'datum',
      'm1',
      'j1',
      'j3',
      'j5',
      'j10',
      'seitauflage',
      'geschaeftsjahr',
      'laufendesjahr',
    ],
  },
  {
    name: 'cixon_wertentwicklung_rollierend',
    value: 'cixon_wertentwicklung_rollierend',
     fields: [
      'datum',
      'k1',
      'k2',
      'k3',
      'k4',
      'k5',
    ],
  },
  {
    name: 'cixon_volatilitaet',
    value: 'cixon_volatilitaet',
    fields: [
      'fondnr',
      'isin',
      'datum',
      'j1',
      'j3',
      'j5',
      'j10',
      'm1',
      'auflage',
      'gesch_jahr',
      'laufendesjahr',
    ],
  },
  {
    name: 'cixon_portfolio',
    value: 'cixon_portfolio',
    fields: [
      'isin',
      'anteliamfv',
      'emittent',
    ],
  },
  {
    name: 'cixon_wertentwpa',
    value: 'cixon_wertentwpa',
    fields: [
      'isin',
      'j3',
      'j5',
      'j10',
      'seitauflage',
      'datum',
    ],
  },
  {
    name: 'cixon_sharp_ratio',
    value: 'cixon_sharp_ratio',
    fields: [
      'sharperatio_1j',
      'sharperatio_3j',
      'sharperatio_5j',
      'sharperatio_seitauflage',
      'sharperatio_geschaeftsjahr',
    ],
  },
];
